/**
 * 资源标识常量统一管理
 * 用于 findByArtworkGroupAPI 接口调用的资源标识符
 */

// 首页相关资源标识
export const INDEX_RESOURCE_MARKS = {
  /** 首页顶部轮播图 */
  TOP_BANNER: 'index-top-banner',
  /** 首页宫格区域 */
  DIAMOND: 'index-diamond',
} as const

// 个人中心相关资源标识
export const PROFILE_RESOURCE_MARKS = {
  /** 个人中心钻石区域 */
  CENTER_DIAMOND: 'center-diamond',
  /** 个人中心更多功能 */
  CENTER_MORE: 'center-more',
  /** 个人中心商家功能 */
  CENTER_MERCHANT: 'center-Merchant',
  /** 会员中心标识 */
  VIP_MARK: 'vip',
} as const

// 工作台相关资源标识
export const WORKBENCH_RESOURCE_MARKS = {
  /** 商家功能 */
  MERCHANT: 'admin-merchant',
  /** 门店功能 */
  STORE: 'admin-store',
  /** 常用功能 */
  COMMON: 'admin-common',
} as const

// 优惠券页面相关资源标识
export const COUPON_RESOURCE_MARKS = {
  /** 优惠券页面轮播图 */
  BANNER: 'coupon-index-banner',
} as const

// 通用资源标识
export const COMMON_RESOURCE_MARKS = {
  /** 通用标识 */
  COMMON: 'common',
  /** Logo 标识 */
  LOGO: 'logo',
} as const

// 导出所有资源标识的联合类型
export type ResourceMarkType =
  | (typeof INDEX_RESOURCE_MARKS)[keyof typeof INDEX_RESOURCE_MARKS]
  | (typeof PROFILE_RESOURCE_MARKS)[keyof typeof PROFILE_RESOURCE_MARKS]
  | (typeof WORKBENCH_RESOURCE_MARKS)[keyof typeof WORKBENCH_RESOURCE_MARKS]
  | (typeof COUPON_RESOURCE_MARKS)[keyof typeof COUPON_RESOURCE_MARKS]
  | (typeof COMMON_RESOURCE_MARKS)[keyof typeof COMMON_RESOURCE_MARKS]

// 导出所有资源标识的扁平化对象（向后兼容）
export const RESOURCE_MARKS = {
  ...INDEX_RESOURCE_MARKS,
  ...PROFILE_RESOURCE_MARKS,
  ...WORKBENCH_RESOURCE_MARKS,
  ...COUPON_RESOURCE_MARKS,
  ...COMMON_RESOURCE_MARKS,
} as const
